{
  "title": "Baca format tradisional secara digital - daripada hanya $0.60 sehari",
  "body": "Akses pada bila-bila masa sahaja. Tiada kontrak!",
  "cta": "Mula membaca dari $0.60 sehari",
  "backToPublicationLink": "Bukan Sekarang"
}
